export default {
  "/course": ["FindYourIdea"],
  "/bonus": ["FindYourIdea"],
  "/case-studies": ["FindYourIdea"],
  "/worksheet": ["FindYourIdea"],
}
